export default function TrashCanIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="14" height="15" viewBox="0 0 14 15" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.5 0H9V1.5H4.5V0ZM0 2.25H13.5V3.75H12V13.5C12 14.325 11.325 15 10.5 15H3C2.175 15 1.5 14.325 1.5 13.5V3.75H0V2.25ZM10.5 13.5V3.75H3V13.5H10.5Z"
        fill="currentColor"
      />
    </svg>
  );
}
